export const CATEGORIES = [
  {
    key: "sme",
    label: "SME / Exporter / Startup",
    desc: "For businesses seeking to list products, access buyers, prepare trade documents, assess export readiness, access logistics, finance and AfCFTA trade opportunities.",
    icon: "store",
  },
  {
    key: "buyer",
    label: "Buyer / Importer / Distributor",
    desc: "For buyers, distributors and procurement organisations looking for verified Nigerian and African suppliers, products and trade partners.",
    icon: "shopping-cart",
  },
  {
    key: "logistics",
    label: "Logistics Provider",
    desc: "For freight, warehousing, cold-chain, courier, customs clearing and transport companies interested in supporting cross-border trade.",
    icon: "truck",
  },
  {
    key: "finance",
    label: "Financial Institution / Investor / Trade Finance",
    desc: "For banks, fintechs, DFIs, investors, insurance providers and trade finance partners interested in financing SMEs or investing in ATFF.",
    icon: "landmark",
  },
  {
    key: "tech",
    label: "Technology / Digital Infrastructure Partner",
    desc: "For software, cloud, cybersecurity, digital identity, payments, API, EDI, data, AI and logistics technology partners.",
    icon: "cpu",
  },
  {
    key: "government",
    label: "Government / Regulator / National Node / Policy",
    desc: "For public-sector and institutional stakeholders interested in SME onboarding, National Nodes, digital trade data, compliance workflows and policy dashboards.",
    icon: "building-2",
  },
  {
    key: "chamber",
    label: "Chamber / Association / Hub / Development Partner",
    desc: "For chambers, trade associations, innovation hubs, accelerators, development partners and SME networks interested in partnership and member onboarding.",
    icon: "users",
  },
  {
    key: "media",
    label: "Media / Press / General Stakeholder",
    desc: "For media organisations, press contacts, ecosystem observers and general stakeholders interested in updates, interviews, coverage or information.",
    icon: "megaphone",
  },
];

export const MAIN_INTERESTS = [
  "Sell products across Africa",
  "Find buyers",
  "Find suppliers",
  "Access logistics support",
  "Access trade finance",
  "Join B2B matchmaking",
  "Partner with ATFF",
  "Invest in ATFF",
  "Support SME onboarding",
  "Government / policy collaboration",
  "Technology integration",
  "Media / press engagement",
  "Other",
];

export const LEAD_STATUSES = [
  "Hot Lead", "Warm Lead", "SME Onboarding Lead", "Partnership Lead",
  "Investor Lead", "Government/Institutional Lead", "Media Lead", "General Lead",
];
export const FOLLOWUP_STATUSES = [
  "Not Contacted", "Contacted", "Meeting Scheduled", "Onboarding Session Invited",
  "Proposal Sent", "Awaiting Response", "Converted", "Closed",
];
